import styled from 'styled-components'
import Flex from 'components/Flex'
import { COLORS } from 'theme'

export const TableTop = styled(Flex)`
  padding: 5px 20px 0px 20px;
  border-top: 1px solid ${COLORS.GREY_T_90} !important;
`
